import React, { Fragment } from "react";

import { Menu, MenuItem } from "src/banking/components";

class EditOrDeleteMenu extends React.Component {
  state = {
    deleting: false,
    open: false,
  };

  static defaultProps = {
    deleteLabel: "Delete",
    editLabel: "Edit",
    canDelete: false,
    canEdit: true,
  };

  handleChangeOpen = open => {
    this.setState(() => ({
      open,
    }));
  };

  handleClose = () => {
    this.setState(() => ({
      deleting: false,
      open: false,
    }));
  };

  handleEdit = e => {
    e.preventDefault();
    this.handleClose();
    this.props.onStartEditing();
  };

  handleDelete = e => {
    e.preventDefault();
    this.setState({
      deleting: true,
    });
  };

  handleCancelDelete = () => {
    this.setState({
      deleting: false,
      open: false,
    });
  };

  render() {
    const {
      canDelete,
      canEdit,
      renderDeleteConfirmation,
      deleteLabel,
      editLabel,
      children,
    } = this.props;

    const { open, deleting } = this.state;

    return (
      <Menu
        open={open}
        onChangeOpen={this.handleChangeOpen}
        managerKey={deleting ? "deleting" : "not-deleting"}
      >
        {deleting ? (
          renderDeleteConfirmation({
            onCancel: this.handleCancelDelete,
          })
        ) : (
          <Fragment>
            {children}
            {canEdit ? (
              <MenuItem
                title={editLabel}
                onClick={this.handleEdit}
                iconName="edit"
                first={true}
              />
            ) : null}
            {canDelete ? (
              <MenuItem
                title={deleteLabel}
                onClick={this.handleDelete}
                color="alert"
                iconName="delete"
                first={!canEdit}
              />
            ) : null}
          </Fragment>
        )}
      </Menu>
    );
  }
}

export default EditOrDeleteMenu;



// WEBPACK FOOTER //
// ./src/banking/components/Menu/EditOrDeleteMenu.js